import { render, staticRenderFns } from "./ExpCard.vue?vue&type=template&id=5445de96&scoped=true&"
import script from "./ExpCard.vue?vue&type=script&lang=js&"
export * from "./ExpCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpCard.vue?vue&type=style&index=0&id=5445de96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445de96",
  null
  
)

export default component.exports